export function mobileMenu(e) {
  const button = document.getElementById("navbar-button");
  button.querySelector('[data-svg-icon="hamburger"]').classList.toggle("hidden");
  button.querySelector('[data-svg-icon="cross"]').classList.toggle("hidden");
}
